import { ArcLayer } from "@deck.gl/layers";

export default class AnimatedArcLayer extends ArcLayer {
    // This method is called once when the layer is initialized.
    initializeState() {
        // This is a Deck.gl lifecycle method. It's good practice to call the parent's method first.
        super.initializeState();

        // We're extending the layer with a new attribute.
        // The AttributeManager helps Deck.gl manage data passed to the GPU.
        this.getAttributeManager().addInstanced({
            // The name of our new attribute.
            instanceRandom: {
                // It's a single floating-point number.
                size: 1,
                // We'll tell the layer how to access this value from our data objects.
                // The layer will look for a prop named 'getRandom' (see App.js).
                accessor: "getRandom",
            },
        });
    }

    getShaders() {
        return {
            ...super.getShaders(),
            inject: {
                // We need to declare our new 'instanceRandom' attribute in the shader.
                // Attributes are variables that have a different value for each instance (arc).
                "vs:#decl": `
          uniform float currentTime;
          attribute float instanceRandom;
        `,
                "vs:#main-end": `
          // We add the unique 'instanceRandom' value to our animation calculation.
          // This offsets the start time of the animation for each arc individually.
          float animated_ratio = mod(segmentRatio - currentTime + instanceRandom, 1.0);

          // This creates a smooth pulse that is 10% of the arc's length.
          float pulse_width = 0.9;
          float in_pulse = smoothstep(0.0, pulse_width, animated_ratio) - smoothstep(pulse_width, pulse_width * 2.0, animated_ratio);

          // Multiply the vertex's alpha by our pulse, making it visible only inside the pulse.
          vColor.a *= in_pulse;
        `,
            },
        };
    }

    // This method is called repeatedly to draw the layer.
    draw(opts) {
        // Pass the 'currentTime' prop from our React app to the shader as a uniform.
        this.state.model.setUniforms({
            currentTime: this.props.currentTime || 0,
        });
        super.draw(opts);
    }
}
